import { TypeEnum } from "../../../models/template/type.enum";


export interface ChannelConfig {
  label: string;
  iconClass: string;
  routePrefix: string;
  typeSuffix: string;
  typeEnum: TypeEnum;
  emptyText: string;
  phaseSuffix:string;
}

export const CHANNEL_CONFIGS: ChannelConfig[] = [
  {
    label: 'Email',
    iconClass: 'pi pi-envelope me-2 channel-icon',
    routePrefix: '/email-template/',
    typeSuffix: 'email',
    typeEnum: TypeEnum.EMAIL,
    emptyText: 'No email templates',
    phaseSuffix: 'emailChannels'
  },
  {
    label: 'SMS',
    iconClass: 'pi pi-mobile me-2 channel-icon',
    routePrefix: '/sms-template/',
    typeSuffix: 'sms',
    typeEnum: TypeEnum.SMS,
    emptyText: 'No SMS templates',
    phaseSuffix: 'smsChannels'
  },
  {
    label: 'Web Push',
    iconClass: 'pi pi-bell me-2 channel-icon',
    routePrefix: '/web-push-template/',
    typeSuffix: 'webpush',
    typeEnum: TypeEnum.WEBPUSH,
    emptyText: 'No web push templates',
    phaseSuffix: 'webPushChannels'
  },
  {
    label: 'Push',
    iconClass: 'pi pi-android me-2 channel-icon',
    routePrefix: '/push-template/',
    typeSuffix: 'push',
    typeEnum: TypeEnum.PUSH,
    emptyText: 'No push templates',
    phaseSuffix: 'pushChannels'
  },
  {
    label: 'Viber',
    iconClass: 'pi pi-comments me-2 channel-icon',
    routePrefix: '/viber-template/',
    typeSuffix: 'viber',
    typeEnum: TypeEnum.VIBER,
    emptyText: 'No Viber templates',
    phaseSuffix: 'viberChannels'
  },
  {
    label: 'RCS',
    iconClass: 'pi pi-send me-2 channel-icon',
    routePrefix: '/rcs-template/',
    typeSuffix: 'rcs',
    typeEnum: TypeEnum.RCS,
    emptyText: 'No RCS templates',
    phaseSuffix: 'rcsChannels'
  },
  {
    label: 'Whatsapp',
    iconClass: 'bi bi-whatsapp me-2 channel-icon',
    routePrefix: '/whatsapp-template/',
    typeSuffix: 'whatsapp',
    typeEnum: TypeEnum.WHATSAPP,
    emptyText: 'No Whatsapp templates',
    phaseSuffix: 'whatsappChannels'
  }
];
